import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useAppContext } from '../context/AppContext';
export const Checkout = () => {
  const {
    setCurrentPage,
    userName,
    setUserName,
    userEmail,
    setUserEmail,
    orderBump,
    setOrderBump,
    timeLeft
  } = useAppContext();
  const [paymentMethod, setPaymentMethod] = useState('card');
  const handleCheckout = () => {
    setCurrentPage('thanks');
  };
  const totalPrice = orderBump ? 324 : 297;
  return <div className="min-h-screen bg-bg pb-16" data-id="element-19">
      <div className="max-w-[720px] mx-auto px-5 pt-6" data-id="element-20">
        <div className="bg-surface rounded-2xl p-6 text-center mb-5" data-id="element-21">
          <h2 className="text-[24px] font-extrabold text-dark mb-1" data-id="element-22">
            🎉 ¡Excelente decisión!
          </h2>
          <p className="text-[15px] text-textlight" data-id="element-23">
            Estás a 60 segundos de activar tu Certificación Europea en IA
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_380px] gap-5 items-start" data-id="element-24">
          {/* Left: Form */}
          <div data-id="element-25">
            <div className="text-[13px] font-bold uppercase tracking-[1px] text-textlight mb-2.5" data-id="element-26">
              PASO 1: TUS DATOS
            </div>
            <input type="text" value={userName} onChange={e => setUserName(e.target.value)} className="w-full border-2 border-border rounded-lg py-3 px-3.5 text-[15px] text-text outline-none focus:border-primary transition-colors bg-white mb-1" placeholder="Nombre completo" data-id="element-27" />
            <small className="text-[11px] text-textlight block mb-2.5" data-id="element-28">
              Tal como aparecerá en tu certificado europeo
            </small>

            <input type="email" value={userEmail} onChange={e => setUserEmail(e.target.value)} className="w-full border-2 border-border rounded-lg py-3 px-3.5 text-[15px] text-text outline-none focus:border-primary transition-colors bg-white mb-2.5" placeholder="tu@email.com" data-id="element-29" />

            <select className="w-full border-2 border-border rounded-lg py-3 px-3.5 text-[15px] text-text outline-none focus:border-primary transition-colors bg-white mb-5" data-id="element-30">
              <option value="" data-id="element-31">🌎 Selecciona tu país</option>
              <option data-id="element-32">🇲🇽 México</option>
              <option data-id="element-33">🇨🇴 Colombia</option>
              <option data-id="element-34">🇦🇷 Argentina</option>
              <option data-id="element-35">🇨🇱 Chile</option>
              <option data-id="element-36">🇵🇪 Perú</option>
              <option data-id="element-37">🇪🇨 Ecuador</option>
              <option data-id="element-38">🌎 Otro país de LATAM</option>
            </select>

            <div className="text-[13px] font-bold uppercase tracking-[1px] text-textlight mb-2.5 pt-4 border-t border-border" data-id="element-39">
              PASO 2: MÉTODO DE PAGO
            </div>

            <div className="flex gap-2 flex-wrap mb-3" data-id="element-40">
              {[{
              id: 'card',
              label: '💳 Tarjeta'
            }, {
              id: 'paypal',
              label: '🅿️ PayPal'
            }, {
              id: 'mercado',
              label: '📱 Mercado Pago'
            }, {
              id: 'transfer',
              label: '🏦 Transferencia'
            }].map(method => <div key={method.id} onClick={() => setPaymentMethod(method.id)} className={`border-2 rounded-lg py-2.5 px-4 cursor-pointer text-[14px] flex items-center gap-1.5 transition-all
                    ${paymentMethod === method.id ? 'border-primary bg-[#FFF3E0] text-primary font-semibold' : 'border-border'}`} data-id="element-41">
                  {method.label}
                </div>)}
            </div>

            {paymentMethod === 'card' && <div className="space-y-2.5 mb-4" data-id="element-42">
                <input type="text" className="w-full border-2 border-border rounded-lg py-3 px-3.5 text-[15px] text-text outline-none focus:border-primary transition-colors bg-white" placeholder="Número de tarjeta" data-id="element-43" />
                <div className="grid grid-cols-2 gap-2.5" data-id="element-44">
                  <input type="text" className="w-full border-2 border-border rounded-lg py-3 px-3.5 text-[15px] text-text outline-none focus:border-primary transition-colors bg-white" placeholder="MM/AA" data-id="element-45" />
                  <input type="text" className="w-full border-2 border-border rounded-lg py-3 px-3.5 text-[15px] text-text outline-none focus:border-primary transition-colors bg-white" placeholder="CVV" data-id="element-46" />
                </div>
                <input type="text" className="w-full border-2 border-border rounded-lg py-3 px-3.5 text-[15px] text-text outline-none focus:border-primary transition-colors bg-white" placeholder="Nombre en la tarjeta" data-id="element-47" />
              </div>}

            {/* ORDER BUMP */}
            <div className="bg-[#FFF8F0] border-2 border-dashed border-primary rounded-xl p-4 my-4" data-id="element-48">
              <div className="bg-primary text-white text-[11px] font-bold uppercase tracking-[1px] py-1 px-2.5 rounded-md inline-block mb-2.5" data-id="element-49">
                ⚡ AÑADE A TU ORDEN — SOLO AQUÍ
              </div>
              <div className="flex gap-2.5 items-start" data-id="element-50">
                <input type="checkbox" checked={orderBump} onChange={e => setOrderBump(e.target.checked)} className="w-5 h-5 border-2 border-primary rounded cursor-pointer shrink-0 mt-0.5 accent-primary" data-id="element-51" />
                <div data-id="element-52">
                  <h4 className="text-[14px] font-bold text-dark mb-1" data-id="element-53">
                    🚀 Sesión en Vivo de Implementación Grupal (90 min)
                  </h4>
                  <p className="text-[13px] text-textlight leading-[1.5]" data-id="element-54">
                    Implementa el Método CERTO en un proyecto real con guía
                    directa del instructor. Grabada + Q&A + Certificado de
                    participación adicional.
                  </p>
                  <div className="text-[15px] mt-1.5" data-id="element-55">
                    <s className="text-textlight" data-id="element-56">$97 USD</s> →{' '}
                    <strong className="text-primary" data-id="element-57">Solo $27 USD</strong>
                  </div>
                </div>
              </div>
            </div>

            {/* Security Badges */}
            <div className="flex gap-1.5 flex-wrap justify-center my-3.5" data-id="element-58">
              <div className="bg-surface rounded-md py-1 px-2.5 text-[11px] text-textlight flex items-center gap-1" data-id="element-59">
                🔒 SSL 256-bit
              </div>
              <div className="bg-surface rounded-md py-1 px-2.5 text-[11px] text-textlight flex items-center gap-1" data-id="element-60">
                💳 VISA
              </div>
              <div className="bg-surface rounded-md py-1 px-2.5 text-[11px] text-textlight flex items-center gap-1" data-id="element-61">
                💳 Mastercard
              </div>
              <div className="bg-surface rounded-md py-1 px-2.5 text-[11px] text-textlight flex items-center gap-1" data-id="element-62">
                🅿️ PayPal
              </div>
            </div>

            <button onClick={handleCheckout} className="bg-primary hover:bg-primary-hover text-white border-none rounded-xl py-4 px-8 text-[16px] font-bold cursor-pointer w-full block transition-all duration-200 shadow-primary hover:-translate-y-0.5" data-id="element-63">
              🔒 COMPLETAR MI CERTIFICACIÓN →
            </button>
            <p className="text-[12px] text-textlight text-center mt-2" data-id="element-64">
              Al completar tu compra aceptas nuestros Términos y Condiciones
            </p>
          </div>

          {/* Right: Order Summary */}
          <div className="bg-white rounded-2xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.08)] sticky top-20" data-id="element-65">
            <h3 className="text-[16px] font-bold text-dark mb-3.5" data-id="element-66">
              📦 RESUMEN DE TU ORDEN
            </h3>

            <div className="flex justify-between text-[13px] py-2 border-b border-border gap-2" data-id="element-67">
              <span className="text-text flex-1" data-id="element-68">8 Módulos Prácticos</span>
              <span className="text-textlight line-through whitespace-nowrap" data-id="element-69">
                $876
              </span>
            </div>
            <div className="flex justify-between text-[13px] py-2 border-b border-border gap-2" data-id="element-70">
              <span className="text-text flex-1" data-id="element-71">
                Certificado Europeo Oficial
              </span>
              <span className="text-success whitespace-nowrap" data-id="element-72">INCLUIDO</span>
            </div>
            <div className="flex justify-between text-[13px] py-2 border-b border-border gap-2" data-id="element-73">
              <span className="text-text flex-1" data-id="element-74">Pack Plantillas IA</span>
              <span className="text-textlight line-through whitespace-nowrap" data-id="element-75">
                $197
              </span>
            </div>
            <div className="flex justify-between text-[13px] py-2 border-b border-border gap-2" data-id="element-76">
              <span className="text-text flex-1" data-id="element-77">Guía Prompts CERTO</span>
              <span className="text-textlight line-through whitespace-nowrap" data-id="element-78">
                $97
              </span>
            </div>
            <div className="flex justify-between text-[13px] py-2 border-b border-border gap-2" data-id="element-79">
              <span className="text-text flex-1" data-id="element-80">Comunidad Privada LATAM</span>
              <span className="text-textlight line-through whitespace-nowrap" data-id="element-81">
                $97
              </span>
            </div>

            {orderBump && <div className="flex justify-between text-[13px] py-2 border-b border-border gap-2" data-id="element-82">
                <span className="text-text flex-1" data-id="element-83">
                  ✅ Sesión en Vivo Grupal
                </span>
                <span className="text-primary whitespace-nowrap" data-id="element-84">+$27</span>
              </div>}

            <div className="mt-3 pt-3 border-t-2 border-primary flex justify-between items-center" data-id="element-85">
              <span className="text-[15px] font-bold" data-id="element-86">HOY PAGAS:</span>
              <span className="text-[28px] font-black text-primary" data-id="element-87">
                ${totalPrice}
              </span>
            </div>
            <p className="text-[12px] text-textlight text-center mt-2" data-id="element-88">
              O 3 pagos de $109 USD
            </p>

            <div className="bg-[#B71C1C] text-white rounded-xl p-3 text-center mt-3.5" data-id="element-89">
              <p className="text-[12px] mb-1" data-id="element-90">⏱️ Oferta expira en:</p>
              <div className="text-[28px] font-extrabold tracking-[2px] leading-none" data-id="element-91">
                {timeLeft}
              </div>
            </div>

            <div className="bg-[#E8F5E9] rounded-xl p-3.5 mt-3 text-center" data-id="element-92">
              <div className="text-[28px]" data-id="element-93">🛡️</div>
              <div className="text-[13px] text-[#1B5E20] font-bold mt-1" data-id="element-94">
                Garantía 15 días
              </div>
              <div className="text-[12px] text-[#2E7D32]" data-id="element-95">
                Devolución 100% sin preguntas
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};